import React, { Component } from 'react';
import { Modal, ModalBody, ModalHeader, ModalFooter, Table, Button } from 'reactstrap';
import i18n from '../../../i18next';
import MaterialIcon from 'material-icons-react';

import { loadCustomerCodes, disableCode } from '../../../actions/restaurants/loyalty/LoyaltyUsersActions';
import { connect } from 'react-redux';
import PopoverItem from '../../common/PopoverItem';
import { isUserAllowedToAddBrands } from '../../../utils/CommonUtils';

class PromoCodesModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            modal: this.props.modal,
            confirmModal: false,
            codeId: null
        }

        this.toggleConfirmModal = this.toggleConfirmModal.bind(this);
        this.onClickConfirm = this.onClickConfirm.bind(this);
    }

    componentDidMount() {
        if (this.props.userId !== -1) {
            this.props.loadCustomerCodes(this.props.restaurantId, this.props.userId);
        }
    }

    toggleConfirmModal(codeId) {
        this.setState({
            ...this.state,
            codeId,
            confirmModal: !this.state.confirmModal
        })
    }

    onClickConfirm() {
        this.props.disableCode(this.state.codeId, () => {
            this.toggleConfirmModal();
            this.props.toggle();
        })
    }

    renderCustomerCodes() {
        const isUserIsAdminOrMasterAdmin = isUserAllowedToAddBrands(this.props.currentlyLoggedInUser);

        if (this.props.customerCodes) {
            let content = this.props.customerCodes;
            const { activeCode } = this.props.styles;

            return content.map((code, i) => {
                let key = { 'key': i };

                return (
                    <tr style={{ cursor: 'pointer' }} {...key} className="d-flex">
                        <td className="col-2" style={this.props.styles.textOverflowHidden}>
                            <PopoverItem id={'code' + i} item={code.code} styles={this.props.styles} />
                        </td>
                        <td className={isUserIsAdminOrMasterAdmin ? "col-2" : "col-3"} style={this.props.styles.textOverflowHidden}>
                            <PopoverItem id={'createDate' + i} item={code.createDate} styles={this.props.styles} />
                        </td>
                        <td className={isUserIsAdminOrMasterAdmin ? "col-2" : "col-3"} style={this.props.styles.textOverflowHidden}>
                            <PopoverItem id={'expDate' + i} item={code.expDate} styles={this.props.styles} />
                        </td>
                        <td className="col-2" style={this.props.styles.textOverflowHidden}>
                            <PopoverItem id={'status' + i} item={code.statusDisplayName} styles={this.props.styles} />
                        </td>
                        <td className="col-2" style={this.props.styles.textOverflowHidden}>
                            <PopoverItem id={'value' + i} item={code.value} styles={this.props.styles} />
                        </td>
                        {
                            isUserIsAdminOrMasterAdmin ?
                                <td className="col-2" style={{ cursor: 'default' }}>
                                    <span
                                        style={code.status === 'ACTIVE' ? activeCode : null}
                                        onClick={code.status === 'ACTIVE' ? () => this.toggleConfirmModal(code.id) : () => { }}>
                                        {i18n.t('screens:loyaltyScreen.disable')}
                                    </span>
                                </td> : null
                        }
                    </tr>
                );
            });
        } else {
            return <div></div>;
        }
    }

    renderCustomerCodesTable() {
        const isUserIsAdminOrMasterAdmin = isUserAllowedToAddBrands(this.props.currentlyLoggedInUser);

        if (this.props.customerCodes && this.props.customerCodes.length !== 0) {
            return (
                <Table responsive hover>
                    <thead>
                        <tr className="d-flex">
                            <th className="col-2">{i18n.t('screens:loyaltyScreen.codeTable.code')}</th>
                            <th className={isUserIsAdminOrMasterAdmin ? "col-2" : "col-3"}>{i18n.t('screens:loyaltyScreen.codeTable.createDate')}</th>
                            <th className={isUserIsAdminOrMasterAdmin ? "col-2" : "col-3"}>{i18n.t('screens:loyaltyScreen.codeTable.expDate')}</th>
                            <th className="col-2">{i18n.t('screens:loyaltyScreen.codeTable.status')}</th>
                            <th className="col-2">{i18n.t('screens:loyaltyScreen.codeTable.value')}</th>
                            {
                                isUserIsAdminOrMasterAdmin ?
                                    <th className="col-2">{i18n.t('screens:loyaltyScreen.codeTable.disableCode')}</th> : null
                            }
                        </tr>
                    </thead>
                    <tbody>
                        {this.renderCustomerCodes()}
                    </tbody>
                </Table>
            );
        } else {
            return (
                <div>{i18n.t('screens:loyaltyScreen.noCodesForUser')}</div>
            );
        }
    }

    renderConfirmDisableCodeModal() {
        return (
            <Modal isOpen={this.state.confirmModal} toggle={this.toggleConfirmModal}>
                <ModalHeader className="modalHeader" toggle={this.toggleConfirmModal}>
                    {i18n.t('screens:loyaltyScreen.codeTable.disableCode')}
                </ModalHeader>
                <ModalBody>
                    {i18n.t('screens:loyaltyScreen.disableCodeWarning')}
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={this.onClickConfirm}><MaterialIcon icon="check" color="#fff"
                        size={20} />&nbsp;{i18n.t('common:buttons.confirm')}</Button>{' '}
                    <Button color="outline-primary" onClick={this.toggleConfirmModal}>{i18n.t('common:buttons.cancel')}</Button>
                </ModalFooter>
            </Modal>
        );
    }

    render() {
        const isUserIsAdminOrMasterAdmin = isUserAllowedToAddBrands(this.props.currentlyLoggedInUser);

        return (
            <React.Fragment>
                <Modal size={isUserIsAdminOrMasterAdmin ? 'lg' : ''} isOpen={this.state.modal} toggle={this.props.toggle}>
                    <ModalHeader toggle={this.props.toggle}>{this.props.userName} {i18n.t('screens:loyaltyScreen.codes')}</ModalHeader>
                    <ModalBody>
                        {this.renderCustomerCodesTable()}
                    </ModalBody>
                </Modal>
                {
                    this.state.confirmModal ?
                        this.renderConfirmDisableCodeModal()
                        : null
                }
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        customerCodes: state.loyaltyUserCodes,
        currentlyLoggedInUser: state.user
    }
};

export default connect(mapStateToProps, { loadCustomerCodes, disableCode })(PromoCodesModal);


// WEBPACK FOOTER //
// ./src/components/restaurants/loyalty/PromoCodesModal.js